import { render, staticRenderFns } from "./expansion.vue?vue&type=template&id=0dc197ea&"
import script from "./expansion.vue?vue&type=script&lang=js&"
export * from "./expansion.vue?vue&type=script&lang=js&"
import style0 from "./expansion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports